import React from "react"

import {
	Box,
	Button,
	Paper,
	Typography,
} from "@mui/material"

import { SbCard } from "components/commons/sb-card/sb-card"
import { DashboardCardInfo } from "./models"
import { Link } from "react-router-dom"

export interface DashboardCardProps {
	cardType: DashboardCardInfo
	navigateTo?: string
	value?: number | string
	isPercentage?: boolean
	notifications?: number
	showNotificationsBadge?: boolean
	percentage?: number
	customFooter?: React.ReactElement

	onClick?: React.MouseEventHandler
}
export interface DashboardCardState {
}
export class DashboardCard extends React.Component<DashboardCardProps, DashboardCardState> {
	static defaultProps = {
		showNotificationsBadge: true,
	}

	private calculateValue = () => {
		if (this.props.value === undefined) {
			return "-"
		}

		if (typeof this.props.value === "number") {
			return this.props.value
				.toFixed(2)
				.replace(/\.00/g, "")
				.replace(/\./g, ",")
		} else {
			return this.props.value
		}
	}

	private calculatePercentage = () => {
		if (this.props.percentage === undefined) {
			return "-"
		}

		if (this.props.percentage >= 0) {
			return '+' + this.props.percentage + '%'
		}
		return this.props.percentage + '%'
	}

	private percentageSx = (): any => {
		if (this.props.percentage !== undefined && this.props.percentage >= 0) {
			return {}
		}

		return {
			color: "primary.contrastText",
			backgroundColor: "black",
		}
	}

	private percentageParse = (value: any) => {

		if (this.props.isPercentage)
			return `${value} %`

		return value
	}

	render() {
		let { cardType } = this.props

		return (
			<SbCard
				avatarIcon={cardType.avatarIcon}
				backgroundImage={cardType.background}
				title={cardType.title}
				mainValue={this.percentageParse(this.calculateValue())}
				notifications={this.props.notifications ?? 0}
				showNotificationsBadge={this.props.showNotificationsBadge}
				avatarBackgroundColour={cardType.avatarColour}
				onClick={this.props.onClick}
				height={"fit-content"}
			>
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: 1,
						mt: 1
					}}
				>
					{
						this.props.customFooter === undefined &&
						this.props.percentage !== undefined &&
						<Box
							sx={{
								display: "flex",
								alignItems: "center",
								width: "100%"
							}}
						>
							<Paper sx={{
								height: '0.85em',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								py: 0,
								px: 1,
								mr: 1,
								...this.percentageSx()
							}} elevation={0}>
								<Typography
									sx={{ fontWeight: 'bold', fontSize: "0.55em", lineHeight: "0.55em" }}>
									{this.calculatePercentage()}
								</Typography>
							</Paper>
							<Typography sx={{ color: 'white', fontSize: "0.85em" }}>
								Rispetto al mese precedente
							</Typography>
						</Box>
					}
					{
						this.props.navigateTo &&
						<Box
							sx={{
								display: "flex",
								justifyContent: "right"
							}}
						>
							<Button
								component={Link}
								to={this.props.navigateTo}
								type="button"
								variant="contained"
								color="secondary"
								disableElevation								
								sx={{
									px: 2.25,
									py: 1.1,
									minHeight: 40,
									minWidth: 160,
									color: "primary.contrastText",
									fontSize: "0.85em",
									textTransform: "none",
									visibility: this.props.cardType.actionButton ? "visible" : "hidden"
								}}
							>
								{this.props.cardType.actionButton ? this.props.cardType.actionButton : "  empty  "}
							</Button>
						</Box>
					}
				</Box>
			</SbCard>
		)
	}
}
